@if (!isLoading) {
  @if (title) {
    <sd-title [titleLevel]="titleLevel" class="c__title" customClass="brand--h4">
      {{title}}
    </sd-title>
  }
  @if (subtitle) {
    <sd-title [titleLevel]="titleLevel + 1" class="c__subtitle" customClass="is-body-m">
      {{subtitle}}
    </sd-title>
  }
  @if (content) {
    <sd-html innerClass="c__content is-wysiwyg" [html]="content" tag="div" />
  }
}

@if (isLoading) {
  <sd-skeleton [appearance]="SkeletonAppearanceEnum.heading" [count]="3" />
}
